import React, { useState, useEffect, useRef } from 'react';
import Card from '@mui/material/Card';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SportsMotorsportsIcon from '@mui/icons-material/SportsMotorsports';
import PersonIcon from '@mui/icons-material/Person';
import Carousel from 'react-material-ui-carousel';
import { Box, Menu, MenuItem } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import EditionCard from './EditionCard';
import FindUserMap from './FindUserMap';
import AddImageCard from './AddImageCard';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import AccessibleForwardIcon from '@mui/icons-material/AccessibleForward';
import FormatListNumberedRtlIcon from '@mui/icons-material/FormatListNumberedRtl';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import axios from 'axios';  // Import axios
import ChatView from './chat/ChatView';

const SearchResultCard = ({ onSearch, deliveryPoint, onClose, userId }) => {
    // Move the destructured data into state so it can be updated dynamically
    const [deliveryData, setDeliveryData] = useState(deliveryPoint);

    const { id, user_id, driver_id, recipient_phone, product, charge, charged, fastmax_transfer_amount, provider_transfer_amount, notes_driver, fastmax_exchange_amount , status, recipient_name, address, image_urls, notes, latitude, longitude, sequence, district, arrival_time } = deliveryData;
    const [chatId, setChatId] = useState(null);
    const [position, setPosition] = useState([latitude || -12.0464, longitude || -77.0428]);
    const initialZoom = 14
    
    const customIcon = L.icon({
        iconUrl: `${process.env.PUBLIC_URL}/logo.png`,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
      });

      function ChangeView({ center, zoom }) {
        const map = useMap();
        map.setView(center, zoom);
        return null;
      }

      useEffect(() => {
        setPosition([latitude || -12.0464, longitude || -77.0428]);
      }, [latitude, longitude]);

    const [showEditionCard, setShowEditionCard] = useState(false);
    const [showMapUserCard, setShowMapUserCard] = useState(false);
    const [showAddImageCard, setShowAddImageCard] = useState(false);
    const [showWhatsAppChat, setShowWhatsAppChat] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null)
    const [selectedDpId, setSelectedDpId] = useState(null)

    const defaultImages = [
        `${process.env.PUBLIC_URL}/churro.webp`,
    ];

    const images = image_urls && image_urls.length > 0 ? image_urls : defaultImages;

    // Fetch updated delivery point data every 3 seconds
    useEffect(() => {
        if (!id) return;

        const POLL_MS = 6000;
        let timer;
        let inFlight = false;
        let stopped = false;
        const ctrl = new AbortController();

        const tick = async () => {
            if (stopped || inFlight) return;     // prevent overlap & stop when unmounted
            inFlight = true;
            try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/search/delivery_point`,
                {
                params: { entrega_id: id },
                signal: ctrl.signal,           // allow cancellation
                }
            );

            if (!stopped && res.status === 200) {
                const data = res.data;
                setDeliveryData(data);

                // if backend includes chat_id (may be null/undefined)
                if (Object.prototype.hasOwnProperty.call(data, 'chat_id') && data.chat_id != null) {
                setChatId(data.chat_id);
                console.log('[chat_id]', data.chat_id); // avoid stale state log
                }
            }
            } catch (err) {
            // ignore intentional cancellations
            if (!(err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED')) {
                console.error('Error fetching updated delivery point:', err);
            }
            } finally {
            inFlight = false;
            if (!stopped) timer = setTimeout(tick, POLL_MS); // schedule next AFTER finish
            }
        };

        // initial fetch
        tick();

        // cleanup when id changes or on unmount
        return () => {
            stopped = true;
            ctrl.abort();          // cancels any in-flight request
            clearTimeout(timer);   // stops future ticks
        };
        }, [id]);

    const handleUserClick = async () => {
        let response;

        response = await axios.get(`${process.env.REACT_APP_API_URL}/api/search/user`, {
            params: { id: user_id },
        });
        onSearch(response.data, 'user');
    };

    const handleDriverClick = async () => {
        let response;

        response = await axios.get(`${process.env.REACT_APP_API_URL}/api/search/user`, {
            params: { id: driver_id },
        });
        onSearch(response.data, 'driver');
    };

    const handleEditClick = () => {
        setShowEditionCard(true);
    };

    const handleCloseEditionCard = () => {
        setShowEditionCard(false);
    };

    const handleCloseChatCard = () => {
        setShowWhatsAppChat(false);
    };

    const handleChatClick = () => {
        setShowWhatsAppChat(true);
    };

    const handleFindUserMapClick = () => {
        setShowMapUserCard(true);
    };

    const handleCloseFindUserMapCard = () => {
        setShowMapUserCard(false);
    };

    const handleCloseAddImageCard = () => {
        setShowAddImageCard(false);
    };

    const handleAddImageClick = () => {
        setShowAddImageCard(true);
    };

    const handleChangeDriverClick = (deliveryPointId) => {
        // Prompt the user for the new driver ID
        const newDriverId = prompt("Por favor, ingresa el nuevo ID del conductor:", "");
    
        // If the user cancels or enters nothing, exit the function
        if (newDriverId === null || newDriverId.trim() === "") {
            alert("Operación cancelada o ID no válido.");
            return;
        }
    
        // Proceed with the API call if a valid ID was entered
        axios.post(`${process.env.REACT_APP_API_URL}/api/update/driver_id`, {
            id: deliveryPointId,  // The delivery point ID
            driver_id: newDriverId.trim()  // The new driver ID, trimmed for extra spaces
        })
        .then(response => {
            alert("El conductor ha sido actualizado exitosamente.");
            // Optionally, update the UI or trigger a state refresh here
        })
        .catch(error => {
            console.error('Error updating driver:', error);
            alert('No se pudo actualizar el conductor.');
        });
    };

    const handleSequenceChange = async () => {
        const newSequence = prompt("Ingrese el nuevo número de secuencia:", deliveryData.sequence || 0);
        if (newSequence && !isNaN(newSequence)) {
          console.log('id ', deliveryData.id);
          try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/change/sequence`, {
              id: deliveryData.id,
              sequence: newSequence
            });
            
            
            if (response.status === 200) {
              alert('Secuencia actualizada exitosamente');
            } else {
              alert('Error al actualizar la secuencia');
            }
          } catch (error) {
            console.error('Error al actualizar la secuencia:', error);
            alert('Ocurrió un error al actualizar la secuencia');
          }
        } else {
          alert('Por favor, ingrese un número válido.');
        }
      };

      

    const handleDeleteClick = async () => {
        const confirmDelete = window.confirm("Are you sure you want to delete this delivery point?");
        if (!confirmDelete) return;

        try {
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/api/delete_delivery_point/${id}`);
            if (response.status === 200) {
                alert('DeliveryPoint deleted successfully');
                onClose();  // Close the card after deletion
            } else {
                alert('Failed to delete DeliveryPoint');
            }
        } catch (error) {
            console.error('Error deleting delivery point:', error);
            alert('Error deleting delivery point');
        }
    };

    const handleMessageClick = async (id, type) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/update_treinta_minutos`, {
                id: id,
                type: type  // either 'order' or 'delivery'
            });

            if (response.status === 200) {
                console.log(`${type} treinta_minutos updated successfully`);
                window.alert(`El chamo llega en 30 minutos`);
            } else {
                console.error(`Failed to update ${type} tres_minutos`);
            }
        } catch (error) {
            console.error(`Error updating ${type} tres_minutos:`, error);
        }
    };

    const handleLocationClick = async (id) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/update_driver_location`, {
                id: id,
            });

            if (response.status === 200) {
                console.log(`falta_ubicacion_driver updated successfully`);
                window.alert(`Falta Ubicaion driver false`);
            } else {
                console.error(`Failed to update  Location_driver`);
            }
        } catch (error) {
            console.error(`Error updating  Location_driver:`, error);
        }
    };

    const handleSlotSelect = async (slotValue, label) => {
        handleSlotClose()
        const ok = window.confirm(`Are you sure between ${label}?`)
        if (!ok) return

        try {
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}/api/delivery_points/${selectedDpId}/slot`,
            {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ slot: slotValue }),
            }
        )
        const json = await res.json()
        if (!res.ok) throw new Error(json.error || 'Unknown error')
        alert(json.message)             // e.g. “Slot updated successfully.”
        // TODO: refresh your list or update state here
        } catch (err) {
        console.error(err)
        alert('Failed to update slot. Please try again.')
        }
    }

    const timeSlots = [
        { value: 1, label: '1–4 pm' },
        { value: 2, label: '2–5 pm' },
        { value: 3, label: '3–6 pm' },
        { value: 4, label: '4–7 pm' },
        { value: 5, label: '5–8 pm' },
    ]

    // Open menu, store which deliveryPoint we’re talking about
    const handleSlotClick = (event, dpId) => {
        setAnchorEl(event.currentTarget)
        setSelectedDpId(dpId)
    }

    const handleSlotClose = () => {
        setAnchorEl(null)
        setSelectedDpId(null)
    }


    const formatArrivalTime = (time) => {
        const date = new Date(time);
        const hour = date.getHours() - 5;
        const minutes = date.getMinutes().toString().padStart(2, '0');
        
        // Calculate the time range (±1 hour)
        const startHour = (hour - 0 + 24) % 24; // To handle negative hours
        
        
        return `${startHour}:${minutes}`;
    };

    return (
        <Box sx={{ position: 'relative' }}>
            <Card sx={{ maxWidth: 600, position: 'relative', top: "80px", left: "10px", zIndex: '2000' }}>
                <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    {recipient_name.length > 25 ? `${recipient_name.substring(0, 25)}...` : recipient_name} {id} {status}
                </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2" color="text.secondary">
                        {address.length > 25 ? `${address.substring(0, 25)}...` : address}, 
                        {charge}
                    </Typography>
                        <Box>
                            <IconButton size="small" onClick={(e) => handleSlotClick(e, deliveryData.id)}>
                                <AccessAlarmIcon />
                            </IconButton>
                            <Menu
                                disablePortal
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleSlotClose}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                PaperProps={{
                                style: {
                                    zIndex: 2000,             // force on top
                                    minWidth: 120,
                                },
                                }}
                            >
                                {timeSlots.map((ts) => (
                                <MenuItem
                                    key={ts.value}
                                    onClick={() => handleSlotSelect(ts.value, ts.label)}
                                >
                                    {ts.label}
                                </MenuItem>
                                ))}
                            </Menu>
                            <IconButton size="small" onClick={() => handleLocationClick(deliveryData.id)}>
                                <LocationOffIcon />
                            </IconButton>
                            <IconButton size="small" onClick={() => handleMessageClick(deliveryData.id, 'delivery')}>
                                <AccessAlarmIcon />
                            </IconButton>
                            <IconButton size="small" onClick={handleSequenceChange}>
                                <FormatListNumberedRtlIcon />
                            </IconButton>

                            <IconButton size="small" onClick={handleUserClick}>
                                <PersonIcon />
                            </IconButton>
                            <IconButton size="small" onClick={handleDriverClick}>
                                <SportsMotorsportsIcon />
                            </IconButton>
                            <IconButton size="small" onClick={handleFindUserMapClick}>
                                <InfoIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                        {notes.length > 25 ? `${notes.substring(0, 25)}...` : notes}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                        CASH: {charged} , FMT: {fastmax_transfer_amount}, PT {provider_transfer_amount}, C {fastmax_exchange_amount}
                        </Typography>
                        <Box>
                            <IconButton size="small" sx={{color: deliveryPoint.package_status === 'in_fastmax' ? 'green' : 'gray'}}>
                                <LocationOffIcon />
                            </IconButton>
                            <IconButton size="small" onClick={() => handleChangeDriverClick(id)}>
                                <AccessibleForwardIcon />
                            </IconButton>
                            <IconButton size="small" onClick={handleAddImageClick}>
                                <AddAPhotoIcon />
                            </IconButton>
                            <IconButton size="small" onClick={handleEditClick}>
                                <EditIcon />
                            </IconButton>
                            <IconButton size="small" onClick={handleDeleteClick}>
                                <DeleteIcon />
                            </IconButton>
                            <IconButton size="small" onClick={handleChatClick}>
                                <WhatsAppIcon />
                            </IconButton>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                            {district} {recipient_phone} {sequence}  {driver_id} {notes_driver} {formatArrivalTime(arrival_time)} {product}
                        </Typography>
                    
                    </Box>
                </CardContent>

                <Box sx={{ display: 'flex', flexDirection: 'row', height: '320px', marginTop: 2 }}>
                    <Box sx={{ width: '35%', height: '100%' }}>
                        <Carousel>
                            {images.map((image, index) => (
                                <CardMedia
                                    key={index}
                                    component="img"
                                    alt={`${recipient_name} image ${index + 1}`}
                                    height="320"
                                    image={image}
                                />
                            ))}
                        </Carousel>
                    </Box>
                    <Box sx={{ width: '65%', height: '100%' }}>
                    <MapContainer center={position} zoom={initialZoom} style={{ width: '100%', height: '100%' }} zoomControl={false}>
                        {/* Using OpenStreetMap tile layer */}
                        <TileLayer
                        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={position} icon={customIcon}>
                        <Popup>
                        Entrega aqui
                        </Popup>
                        </Marker>
                        <ChangeView center={position} zoom={initialZoom} />
                    </MapContainer>
                    </Box>
                </Box>

                <IconButton
                    size="medium"
                    onClick={onClose}
                    style={{ position: 'absolute', top: 7, right: 7, backgroundColor: 'white', zIndex: 1 }}
                >
                    <CloseIcon />
                </IconButton>
            </Card>

            {showEditionCard && (
                <EditionCard deliveryPoint={deliveryData} onClose={handleCloseEditionCard} />
            )}
            {showMapUserCard && (
                <FindUserMap onClose={handleCloseFindUserMapCard} deliveryId={id} />
            )}
            {showAddImageCard && (
                <AddImageCard deliveryId={id} onClose={handleCloseAddImageCard} />
            )}
            {showWhatsAppChat && (
                <Box
                    sx={{
                    position: 'absolute',
                    top: 80,
                    left: 620,
                    width: 500,
                    height: 600,           // explicit height so 100% has meaning
                    p: 2,
                    border: '1px solid #ddd',
                    borderRadius: 2,
                    bgcolor: 'white',
                    zIndex: 3000,
                    overflow: 'hidden',

                    // Force ChatView root <div> to use the Box's size instead of 100vh
                    '& > div:first-of-type': {
                        width: '100% !important',
                        height: '100% !important',
                    },
                    }}
                >
                    <ChatView chatId={chatId} onBackClick={handleCloseChatCard} userId={userId} />
                </Box>
            )}
        </Box>
    );
};

export default SearchResultCard;
